import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const SendNotificationHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Send Notification</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default SendNotificationHeader;
